module.exports = __webpack_public_path__ + "img/post-it.c65c4bff.png";